import React from 'react';
import styles from './FeatureCard.module.scss';
import Text from '../Text/Text';

interface Props {
	icon: string;
	title: string;
	text: string;
}

const FeatureCard: React.FC<Props> = ({ icon, title, text }) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.iconWrapper}>
				<img src={icon} alt='icon' />
			</div>
			<Text className={styles.title} tx={title} />
			<Text className={styles.text} tx={text} />
		</div>
	);
};

export default FeatureCard;
